<template>
  <div>
    <div class="wrapper" @click="$router.go(-1)">
      <van-icon name="arrow-left" class="arrow-left"/>
      <p class="backTitle">{{$route.query.title}}</p>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  components: {
    [Icon.name]: Icon
  },
  created() {}
};
</script>

<style scoped lang="less">
.wrapper {
  width: 100%;
  padding-left: 14px;
  height: 5%;
  margin-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  position: relative;
  .arrow-left {
    font-size: 20px;
  }
  .back {
    margin-left: 8px;
    font-weight: 400;
    color: rgba(65, 65, 65, 1);
    font-size: 18px;
  }
  .backTitle {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    font-weight: 400;
    font-size: 18px;
    color: rgba(65, 65, 65, 1);
  }
}
</style>